
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assisted-living",
      function () {
        return require("private-next-pages/assisted-living.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assisted-living"])
      });
    }
  